import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  Alert,
  Row,
  Col,
  Card,
  Container,
  Spinner,
  Form,
  ButtonGroup,
  Button,
  Dropdown,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarDashboard from "../../components/SidebarDashboard";
import CustomPagint from "../../components/CustomPagint";
import { getPlazasVacantes } from "../../redux/seleccionContratacion/plazas_vacantes/actions";
import config from "../../config";

const Vacancies = (props) => {
  const filters = [
    { id: "codigo", desc: "Código de plaza vacante" },
    { id: "descripcion", desc: "Plaza vacante" },
    { id: "empresa_nombre", desc: "Empresa", authorized_roles: ["administrador"] },
  ];
  //* States
  const [show, setShow] = useState(true);
  // effects
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");
  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);
  const [view, setView] = useState("");

  //Redux
  const { loaderPlazasVacantes, plazasVacantes, plazasVacantesFalla } =
    useSelector((store) => store.plazasVacantes);
  const unidOrg = useSelector((store) => store.auth.unidOrg);
  const userRoles = useSelector((store) => store.auth.userRoles);
  // Variables
  const pages = Math.ceil((plazasVacantes ? plazasVacantes.count : 0) / limit);
  const dispatch = useDispatch();
  const history = useHistory();
  //* Methods
  // const _getPlazasVacantes = (filt = unidOrg) =>
  //   dispatch(
  //     getPlazasVacantes({
  //       codigo_unidad_organizativa: filt,
  //     })
  //   );

  const _getPlazasVacantes = (
    offs = offset,
    lim = limit,
    filt = filter,
    viw = view
  ) =>
    dispatch(
      getPlazasVacantes(
        {
          offset: offs,
          limit: lim,
          filter: filt,
          tipo_busqueda: tipoBusqueda.id,
          // unidad_organizativa: unidOrg,
          vista: viw,
        },
        props.match.params.type === "plazas-no-vacantes"
      )
    );

  useEffect(() => {
    if (userRoles.length > 0) {
      const rolActual = userRoles.filter(
        (usr) =>
          usr === "jefe" ||
          usr === "administrador" ||
          usr === "Responsable_Seleccion_Contratacion" ||
          usr === "alta_direccion"
      )[0];
      setView(rolActual);
      setOffset(0);
      setLimit(10);
      setCurrentPage(1);
      setFilter("");
      _getPlazasVacantes(0, 10, "", rolActual);
    }
  }, [userRoles, props.match.params.type]);

  // useEffect(() => {
  //   if (unidOrg) {
  //     _getPlazasVacantes();
  //   }
  // }, [unidOrg]);

  const onSearch = (e) => {
    e.preventDefault();
    if (!e.target.search.value.trim()) {
      return;
    }
    setFilter(e.target.search.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getPlazasVacantes(oOffset, limit, e.target.search.value);
  };

  const onSearchRole = (e) => {
    e.preventDefault();
    setView(e.currentTarget.value);
    setFilter("");
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getPlazasVacantes(offset, limit, "", e.currentTarget.value);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    setCurrentPage(1);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getPlazasVacantes(oOffset, limit, oSearch);
  };

  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
          {/* <h5 className="text-black-50 m-0 text-uppercase">PLAZAS VACANTES</h5> */}
          <h5 className="text-black-50 m-0 text-uppercase">
            {props.match.params.type.replaceAll("-", " ")}
          </h5>
          <Form onSubmit={onSearch}>
            <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
              <Col>
                <h6>
                  <b>Búsqueda por: {tipoBusqueda.desc}</b>
                </h6>
              </Col>
              <Col xs="auto">
                <Form.Control
                  name="search"
                  type="search"
                  placeholder="Buscar"
                  className="rounded-pill form-control-sm"
                ></Form.Control>
              </Col>
              <Col xs="auto">
                <ButtonGroup>
                  <Button
                    variant="light"
                    size="sm"
                    className="rounded-pill mr-1"
                    onClick={() => seeAll()}
                  >
                    <i className="material-icons">list</i>
                  </Button>
                  <Dropdown className="ml-1 mr-1">
                    <Dropdown.Toggle
                      variant="light"
                      className="btn-sm font rounded-pill"
                    >
                      <i className="material-icons">filter_list</i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {filters.map((item) => {
                        const tieneAcceso = !item.authorized_roles || item.authorized_roles.some(rol => userRoles.includes(rol));

                        return tieneAcceso ? (
                          <Dropdown.Item
                            onClick={() => setTipoBusqueda(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ) : null;
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                </ButtonGroup>
              </Col>
            </Form.Row>
          </Form>
        </div>
        <Row className="mx-2 px-1 justify-content-start align-items-center flex-nowrap">
          {userRoles.filter(
            (usr) =>
              usr === "jefe" ||
              usr === "administrador" ||
              usr === "Responsable_Seleccion_Contratacion" ||
              usr === "alta_direccion"
          ).length > 1 ? (
            <>
              <Col xs="auto">
                <h6>
                  <b>Ver como:</b>
                </h6>
              </Col>
              <Col xs="auto">
                {/* loadingAuth, users */}
                <Form.Control
                  as="select"
                  name="filter"
                  id="filter"
                  placeholder="Buscar"
                  className="rounded-pill form-control-sm"
                  onChange={onSearchRole}
                  style={{ minWidth: "174px" }}
                >
                  {userRoles
                    .filter(
                      (usr) =>
                        usr === "jefe" ||
                        usr === "administrador" ||
                        usr === "Responsable_Seleccion_Contratacion" ||
                        usr === "alta_direccion"
                    )
                    .map((item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    ))}
                </Form.Control>
              </Col>
            </>
          ) : null}
        </Row>
        <hr />
        <Container fluid>
          {plazasVacantesFalla && (
            <Alert variant="danger" className="my-4">
              {plazasVacantesFalla}
            </Alert>
          )}
          {loaderPlazasVacantes ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : plazasVacantes && plazasVacantes.count > 0 ? (
            <div className="mt-4">
              <Row>
                {plazasVacantes.data.map((item) => (
                  <Col sm="3" className="mb-3">
                    <Button
                      variant="link"
                      className="p-0"
                      style={{ width: "100%" }}
                      onClick={() =>
                        history.push(
                          `/seleccion-contratacion/monitor-de-requerimientos/${props.match.params.type
                          }/${item.id}/${item.descripcion.replaceAll(
                            "/",
                            "-"
                          )}/${item.codigo}/${config.roles.find((rol) => rol.rol === view).abrev
                          }`
                        )
                      }
                    >
                      <Card
                        className={
                          props.match.params.type === "plazas-no-vacantes"
                            ? "bg-aurora-no-vacantes"
                            : "bg-aurora"
                        }
                        style={{ height: "220px" }}
                      >
                        <Card.Body className="text-center font-weight-bold text-white ">
                          <Card.Title>
                            <i
                              className="material-icons"
                              style={{ fontSize: "5.5rem" }}
                            >
                              engineering
                            </i>
                          </Card.Title>
                          {item.codigo} / {item.descripcion}
                          <br />
                          {item.list_empresa[0]
                            ? item.list_empresa[0].nombre
                            : "Sin empresa"}
                        </Card.Body>
                      </Card>
                    </Button>
                  </Col>
                ))}
              </Row>
              <CustomPagint
                jContent="justify-content-sm-center"
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={plazasVacantes.count}
                pages={pages}
                pagFunc={_getPlazasVacantes}
              />
            </div>
          ) : (
            <Alert className="my-4" variant="info">
              No sé encontrarón datos
            </Alert>
          )}
        </Container>
      </div>
      {/* <Modal show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title style={{fontSize: '1.1rem'}}>{func ? func.descripcion.length > 37 ? `${func.descripcion.substring(0, 35)}...` : func.descripcion : null}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col sm="6" className="mb-3">
            <Link
              // to="#"
              onClick={() =>
                history.push(`/descriptores-perfiles/seleccion-del-descriptor/${func.id}`)
              }
              style={{width: '100%'}}>
              <Card className="bg-aurora">
                <Card.Body className="text-center font-weight-bold text-white ">
                  <Card.Title>
                    <i className="material-icons" style={{fontSize: '5.5rem'}}>card_travel</i>
                  </Card.Title>
                  Descriptor
                </Card.Body>
              </Card>
            </Link>
          </Col>
          <Col sm="6" className="mb-3">
            <Link 
              to="#"
              style={{width: '100%'}}>
              <Card className="bg-aurora">
                <Card.Body className="text-center font-weight-bold text-white ">
                  <Card.Title>
                    <i className="material-icons" style={{fontSize: '5.5rem'}}>next_week</i>
                  </Card.Title>
                  Asignar competencias
                </Card.Body>
              </Card>
            </Link>
          </Col>
        </Row>
      </Modal.Body>
    </Modal> */}
    </>
  );
};

export default Vacancies;
